import moment from 'moment';

/**
 *
 * @param {string} date an ISO datetime string
 * @param {string} time a HH:mm formatted time string
 * @returns {moment} PST converted moment object
 */
export const convertEstDatetimeToPst = (date, time) => {
  if (!date || !time) return ''
  const pstTime = moment(time, 'HH:mm');
  const pstConvertedDate = moment(date)
    .set({
      hour: pstTime.get('hour'),
      minute: pstTime.get('minute'),
      second: pstTime.get('second'),
    })
    .subtract(3, 'h');
    return pstConvertedDate;
}

/**
 *
 * @param {string} datetime an ISO datetime string
 * @returns {string} formatted datetime e.g. 'Feb 24, 06:29 AM'
 */
const formatDatetime = (datetime, suffix) => {
  suffix = suffix || ''
  if (!datetime) return '';
  const momentDatetime = moment(datetime.replace('Z', ''));
  const year = momentDatetime.year();
  if (year < moment().year()) {
    return momentDatetime.format(`MMM DD, Y[${suffix}]`);
  }
  return momentDatetime.format(`MMM DD, HH:mm\u202FA[${suffix}]`);
};

export default formatDatetime;
